import React, {useContext, useEffect, useState, useMemo} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import i18n from '../../../i18n';
import Spinner from '../../../components/Spinner';
import InputFilter from '../../Filters/InputFilter';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import {Collapse, initTE} from 'tw-elements';
import {getCategoriasReunioes, getEstabelecimentos, getNegocios, getRepresentantes, getVisitas} from '../../../pages/requests';

import DrawerFilter from '../DrawerFilter';
import TablePagination from '../../TablePagination';
import SelectComponent from '../../Selects/SelectComponentFilt';
import MultiSelectColor from '../../Selects/MultiSelectComponent';
import Select from 'react-select';
// import MultiSelectColor from '../../Selects/MultiSelectColor';
import NotFound from '../../NotFound';
import Datepicker from 'react-tailwindcss-datepicker';
import moment from 'moment';
import LoadingModal from '../../LoadingModal';
import axios from 'axios';
import {toast} from 'react-toastify';

function Agenda({
    setEditarAgendamentos,
    representantes,
    categorias,
    onRowClick,
    setRepresentanteFiltro,
    representanteFiltro,
    categoriaFiltro,
    setCategoriaFiltro,

    currentPage,
    setCurrentPage,
    //filtros
    filtroDescricao,
    setfiltroDescricao,
    filtroDtInicio,
    setFiltroDtInicio,
    filtroDtFim,
    setFiltroDtFim,
    filtroCliente,
    setFiltroCliente,
    filtroNegocio,
    setFiltroNegocio,
    filtroEstab,
    setFiltroEstab,
    estabelecimentos,
    filtroCodigo,
    setFiltroCodigo,
    // /filtros
}) {
    const FORMATO_DATA = 'YYYY-MM-DD';

    const {t} = useTranslation();

    const [visitas, setVisitas] = useState([]);
    const {acessos, rep, utilizador, handleLogout, userRepresentante, isCard, openCards} = useContext(Context);

    const [visibilidade, setVisibilidade] = useState(true);
    const [visibilidade2, setVisibilidade2] = useState(true);
    // const [responsaveis, setResponsaveis] = useState([]);
    const [categoriaRecebido, setCategoriaRecebido] = useState('');
    // const [categorias, setCategorias] = useState([]);
    const [semDadosArray, setSemDadosArray] = useState(false);
    const [acessoR, setAcessoR] = useState([]);
    const [search, setSearch] = useState('');
    const [respRecebido, setRespRecebido] = useState(userRepresentante);
    const [obteveResps, setObteveResps] = useState(false);
    const [semDadosEstado, setSemDadosEstado] = useState(false);
    const [totalProdutos, setTotalProdutos] = useState(0);
    const [semDados, setSemDados] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    // FILTROS

    initTE({Collapse});

    const [totalItems, setTotalItems] = useState(0);
    const [sorting, setSorting] = useState({field: '', order: ''});

    const ITEMS_PER_PAGE = 15;

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleRowClick = dados => {
        // setEditarAgendamentos(true);
        onRowClick(dados);
    };

    function handleChangeFiltro() {
        if (
            filtroDescricao ||
            filtroCliente ||
            filtroNegocio ||
            filtroCodigo ||
            filtroDtInicio.startDate ||
            filtroDtFim.startDate ||
            representanteFiltro.length != 0 ||
            categoriaFiltro.length != 0 ||
            filtroEstab
        ) {
            return true;
        } else {
            return false;
        }
    }

    const visitasDados = useMemo(() => {
        let visitasInfo = visitas;

        setTotalItems(visitasInfo.length);

        if (sorting.field) {
            const reversed = sorting.order === 'asc' ? 1 : -1;
            visitasInfo = visitasInfo.sort((a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field]));
        }

        return visitasInfo;
    }, [visitas, currentPage, sorting]);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        acessos.forEach(element => {
            if (element.funcao == 'GESBAP') {
                const acesso = {
                    funcao: element.funcao,
                    consultar: element.consultar,
                    apagar: element.apagar,
                    modificar: element.modificar,
                    criar: element.criar,
                };
                setAcessoR(acesso);
            }
        });
    }, [acessos]);

    // useEffect(() => {
    //     getRepresentantes(lang).then(res => {
    //         setResponsaveis(res.data.representantes);
    //         setObteveResps(true);
    //     });
    // }, []);
    // useEffect(() => {
    //     getCategoriasReunioes(lang).then(res => {
    //         setCategorias(res.data.categorias);
    //     });
    // }, []);

    useEffect(() => {
        window.scrollTo(0, 0);

        const controller = new AbortController();
        const signal = controller.signal;

        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        setVisitas([]);
        setLoading(true);

        debugger;
        getVisitas(
            indexOfFirstItem,
            indexOfLastItem - 1,
            lang,
            signal,
            filtroDtInicio.startDate ?? '',
            filtroDtFim.startDate ?? '',
            filtroCliente,
            filtroNegocio,
            filtroEstab?.value ?? '',
            representanteFiltro.map(item => item.value),
            categoriaFiltro.map(item => item.value),
            filtroDescricao,
            filtroCodigo,
            false,
        )
            .then(res => {
                if (res.data.success) {
                    setVisitas(res.data.reunioes);
                    setTotalProdutos(res.data.totalprodutos);
                    if (res.data.totalprodutos == '0') {
                        setSemDadosEstado(true);
                        setVisibilidade2(false);
                    }
                } else {
                    res.data.errorMessages.map(m =>
                        toast.error(m, {
                            position: 'top-right',
                            autoClose: 5000,
                        }),
                    );
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            })
            .finally(() => {
                setLoading(false);
            });

        return () => {
            controller.abort();
        };
    }, [currentPage, filtroDtInicio, filtroDtFim, filtroCliente, filtroCodigo, filtroNegocio, filtroEstab, categoriaFiltro, representanteFiltro, filtroDescricao]);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        if (search.length == 0 && obteveResps) {
            setVisibilidade2(true);
            getVisitas(0, 14, lang, signal)
                .then(res => {
                    if (res.data.success) {
                        if (res.data.totalprodutos == '0') {
                            setSemDadosEstado(true);
                            setVisibilidade2(false);
                        }
                        setCurrentPage(1);
                        setVisitas(res.data.reunioes);
                        setTotalProdutos(res.data.totalprodutos);
                    } else {
                        res.data.errorMessages.map(m =>
                            toast.error(m, {
                                position: 'top-right',
                                autoClose: 5000,
                            }),
                        );
                    }
                })
                .catch(error => {
                    if (!axios.isCancel(error)) console.log(error);
                });
        } else if (search.length >= 2) {
            setRespRecebido('');
            setCategoriaRecebido('');
            setVisibilidade2(true);
            getVisitas(0, 14, lang, signal)
                .then(res => {
                    if (res.data.success) {
                        setVisitas([]);
                        setCurrentPage(1);
                        setVisitas(res.data.reunioes);
                        setTotalProdutos(res.data.totalprodutos);

                        if (res.data.totalprodutos == '0') {
                            setVisibilidade2(false);
                            setSemDados(true);
                            // setTotalProdutos(1);
                        }
                    } else {
                        res.data.errorMessages.map(m =>
                            toast.error(m, {
                                position: 'top-right',
                                autoClose: 5000,
                            }),
                        );
                    }
                })
                .catch(error => {
                    if (!axios.isCancel(error)) console.log(error);
                });
        }

        return () => {
            controller.abort();
        };
    }, [search]);

    useEffect(() => {
        if (visitas?.length != 0 && semDadosEstado == false) {
            setVisibilidade(false);
            setSemDados(false);
            setVisibilidade2(false);
        } else if (visitas?.length == 0 && semDadosEstado == true) {
            setVisibilidade(false);
            setVisibilidade2(false);
            setSemDadosArray(true);
            // setTotalProdutos(1);
        }
    }, [visitas]);

    function limparFiltros() {
        setCurrentPage(1);
        setfiltroDescricao('');
        setFiltroCliente('');
        setFiltroNegocio('');
        setFiltroCodigo('');
        setFiltroDtInicio({startDate: null, endDate: null});
        setFiltroDtFim({startDate: null, endDate: null});
        setRepresentanteFiltro([]);
        setCategoriaFiltro([]);
        setFiltroEstab(null);
    }

    useEffect(() => {
        if (utilizador == null || utilizador == '') {
            return;
        }

        const controller = new AbortController();
        const signal = controller.signal;

        if (categoriaRecebido != '' || respRecebido != '') {
            setSearch('');
            setVisibilidade2(true);
            getVisitas(0, 14, lang, signal)
                .then(res => {
                    if (res.data.success) {
                        setVisitas(res.data.reunioes);
                        setCurrentPage(1);
                        setTotalProdutos(res.data.totalprodutos);

                        if (res.data.totalprodutos == '0') {
                            setVisibilidade2(false);
                            setSemDados(true);
                            // setTotalProdutos(1);
                        }
                    } else {
                        res.data.errorMessages.map(m =>
                            toast.error(m, {
                                position: 'top-right',
                                autoClose: 5000,
                            }),
                        );
                    }
                })
                .catch(error => {
                    if (!axios.isCancel(error)) {
                        console.log(error);
                    }
                });
        }

        return () => {
            controller.abort();
        };
    }, [respRecebido, utilizador]);

    useEffect(() => {
        if (visitasDados.length != 0 && loading == false) {
            setSemDados(false);
        } else {
            setSemDados(true);
        }
    }, [semDados]);

    return (
        <div>
            {isMobile || isCard ? (
                <div>
                    {visitasDados?.map((dados, index) => (
                        <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                            <h2 className="mb-0" id="headingOne">
                                <button
                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                    type="button"
                                    data-te-collapse-init
                                    data-te-collapse-collapsed
                                    data-te-target={'#flush-collapseThree' + index}
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    <div className="flex flex-row" onClick={() => handleRowClick(dados)}>
                                        {moment(dados.dataI).format(FORMATO_DATA)} | {dados.categoria.value} | {dados.cliente}
                                    </div>
                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                        </svg>
                                    </span>
                                </button>
                            </h2>
                            <div
                                id={'flush-collapseThree' + index}
                                className={openCards ? 'visible' : '!visible hidden'}
                                data-te-collapse-item
                                aria-labelledby="flush-headingThree"
                                data-te-parent="#accordionFlushExample">
                                <div className="px-5 py-4">
                                    <div className="font-medium text-gray-900 dark:text-white flex flex-row">{dados.id}</div>
                                    <div className="font-medium text-gray-900 dark:text-white flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('inicio')}:</div> {moment(dados.dataI).format(FORMATO_DATA)}
                                    </div>
                                    <div className=" font-medium text-gray-900 dark:text-white  flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('fim')}: </div> {moment(dados.dataF).format(FORMATO_DATA)}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('categoria')}: </div> {dados.categoria.value}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('cliente')}: </div> {dados.cliente}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('negocio')}: </div> {dados.projeto}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('estabelecimento')}: </div> {dados.estabelecimento}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}

                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                    </nav>
                </div>
            ) : (
                <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px] z-0">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                            <tr>
                                <th scope="col" className="px-2 py-3">
                                    {t('codigo')}
                                    <InputFilter
                                        value={filtroCodigo}
                                        onSearch={value => {
                                            setFiltroCodigo(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-2 py-3">
                                    {t('dataInicio')}
                                    <Datepicker
                                        displayFormat={FORMATO_DATA}
                                        // maxDate={today}
                                        useRange={false}
                                        asSingle={true}
                                        value={filtroDtInicio}
                                        onChange={newValue => {
                                            setFiltroDtInicio(newValue);
                                            setCurrentPage(1);
                                        }}
                                        inputClassName={`rounded-[5px] mt-2 w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                    />
                                </th>
                                <th scope="col" className="px-2 py-3">
                                    {t('dataFim')}
                                    <Datepicker
                                        displayFormat={FORMATO_DATA}
                                        // maxDate={today}
                                        useRange={false}
                                        asSingle={true}
                                        value={filtroDtFim}
                                        onChange={newValue => {
                                            setFiltroDtFim(newValue);
                                            setCurrentPage(1);
                                        }}
                                        inputClassName={`rounded-[5px] mt-2 w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                    />
                                </th>
                                <th scope="col" className="px-4 py-3">
                                    {t('categoria')}
                                    <MultiSelectColor
                                        isMulti
                                        options={categorias}
                                        value={categoriaFiltro}
                                        onChange={e => {
                                            setCategoriaFiltro(e);
                                            setCurrentPage(1);
                                        }}
                                        noOptionsMessage={t('semopcoes')}
                                        placeholder={t('filtro')}
                                    />
                                </th>
                                <th scope="col" className="px-2 py-3">
                                    {t('cliente')}
                                    <InputFilter
                                        value={filtroCliente}
                                        onSearch={value => {
                                            setFiltroCliente(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-2 py-3">
                                    {t('negocio')}
                                    <InputFilter
                                        value={filtroNegocio}
                                        onSearch={value => {
                                            setFiltroNegocio(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-2 py-3 ">
                                    {t('estabelecimento')}
                                    <div className="flex flex-row ">
                                        <SelectComponent
                                            options={estabelecimentos}
                                            value={filtroEstab}
                                            onChange={e => {
                                                setFiltroEstab(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                        {handleChangeFiltro() ? (
                                            <button
                                                onClick={limparFiltros}
                                                type="button"
                                                className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                <FilterAltOffIcon />
                                            </button>
                                        ) : null}
                                    </div>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {visitasDados.map(dados => (
                                <tr
                                    className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 "
                                    onClick={() => handleRowClick(dados)}>
                                    <td className="px-6 py-1">{dados.id}</td>
                                    <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {moment(dados.dataI).format(FORMATO_DATA)}
                                    </th>
                                    <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {moment(dados.dataF).format(FORMATO_DATA)}
                                    </th>
                                    <td className="px-6 py-1">{dados.categoria.value}</td>
                                    <td className="px-3 py-1 text-blue-600 dark:text-blue-500">{dados.cliente}</td>
                                    <td className="px-2 py-1">{dados.projeto}</td>
                                    <td className="px-6 py-1 ">
                                        <a href="#" className="font-medium  hover:underline">
                                            {dados.estabelecimento}
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {semDados && !loading && <NotFound frase={t('semRegistos')} />}
                    {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}

                    {visitas == 0 && handleChangeFiltro() ? <NotFound frase={t('naoExistemVisitas')} /> : ''}

                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        {totalProdutos != 0 && <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} /> }
                    </nav>
                </div>
            )}
        </div>
    );
}

export default Agenda;
